import { toast } from "@/design-system/components/Toast/Toast";

import { makeRequest, userIsFPEmployee } from "./util";
import FeatureFlag from "./FeatureFlag";

import { userHasAccess } from "./access-control/permissions";
import { User } from "./components/users/types";
import {
  RBACAccessLevel,
  RBACDomain,
  RolePermissions,
} from "./access-control/types";

export const AUDIT_LOGS_PATH = "/settings/audit-logs";

export function allowAuditSelfServe(
  flag: {
    (featureName: FeatureFlag): boolean;
  },
  user: User | undefined,
  permissions: RolePermissions | undefined,
) {
  return (
    userIsFPEmployee() ||
    (flag("selfServeAuditLog") &&
      userHasAccess(
        user,
        permissions,
        RBACDomain.auditLog,
        RBACAccessLevel.read,
      ))
  );
}

function downloadAuditLogs(data: string, accountId: string) {
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(data),
  );
  element.setAttribute("download", `${accountId}-auditlog.csv`);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function makeAuditLogDownloadRequest(account: { projects: any[] }) {
  makeRequest("get_hipaa_allowlist_auditlog", {})
    .then((response) => {
      const csvData = response.data as string;
      if (!response.data) {
        toast.error("No audit logs found.");
        return;
      }

      const accountId =
        account.projects.length >= 1 ? account.projects[0].accountID : "";
      downloadAuditLogs(csvData, accountId);
    })
    .catch((error) => {
      console.error(error);
      toast.error("Something went wrong");
    });
}
